
import { LanguageString, TimeLabelMap } from './time-label-map';
// Create a LanguageString instead of using Language directly to be backward compatible with all users of DurationPipe for now

export class DurationFormatter {

    public static transform(value: number | number[], showSeconds: boolean = false, showMinutes: boolean = true, convertFactor: number = 1, language: LanguageString = 'en'): string {
        if(value == 0) {
            const unit = showSeconds ? 's' : 'm';
            return this.getTimeLabel(language, unit, 0);
        }
        if(value == Infinity) return '∞';
        if(!value) return '∞';

        const timeLabel = (Array.isArray(value) ? DurationFormatter.timeInterval(value, showMinutes, language, convertFactor) : this.secondsToHms(value, showSeconds, showMinutes, language, convertFactor));
        return timeLabel || `< ${this.getTimeLabel(language, 'm', 1)}`;
    }

    public static timeInterval(value: number[], showMinutes: boolean, language: LanguageString, convertFactor: number): string {
        let [from, to] = value;
        const fromLabel = this.secondsToHms(from, false, showMinutes, language, convertFactor);
        const toLabel = this.secondsToHms(to, false, showMinutes, language, convertFactor);
        if(toLabel) return `${fromLabel || '0'} - ${toLabel}`;
        return '';
    }

    public static secondsToHms(d: number, showSeconds: boolean, showMinutes: boolean, language: LanguageString, convertFactor: number): string {
        // Convert by factor (1 if not given)
        d = d * convertFactor;

        // Round initial numbers
        var h = Math.floor(d / 3600);
        var m = Math.floor((d % 3600) / 60);
        var s = Math.floor(d) - (m * 60) - (h * 60 * 60);
        if(s > 30) m += 1;
        if(m > 30) h += 1;

        // Format with hours
        var hour = h > 0 ? this.getTimeLabel(language, 'h', h) : "";
        var minute = '';
        var sec = '';

        if(showMinutes || h < 1) {
            // Format with minutes used in most places (standard)
            minute = m > 0 ? this.getTimeLabel(language, 'm', m) : "";
        }
        if(showSeconds) {
            // Format with seconds used in media player etc
            sec = this.getTimeLabel(language, 's', s);
        }

        return (hour + (hour && minute ? ' ' : '') + minute + (minute && sec ? ' ' : '') + sec);
    }

    /**
     * Get time label depending on language, unit and amount
     */
    private static getTimeLabel(language: LanguageString, unit: 's' | 'm' | 'h', amount: number): string {
        return `${amount} ${amount == 1 ? TimeLabelMap[language][unit].singular : TimeLabelMap[language][unit].plural}`;
    }

}
